<template>
  <transition name="fade">
    <div
      v-if="popupAberto"
      class="popup-whatsapp"
      @click.self="fecharPopup"
    >
      <div class="popup-conteudo">
        <h3>💬 Fale conosco via WhatsApp</h3>
        <p>Selecione um ou mais serviços de seu interesse:</p>

        <ul class="lista-assuntos">
          <li
            v-for="(assunto, i) in assuntos"
            :key="i"
            :class="{ ativo: selecionados.includes(assunto) }"
            @click="toggleSelecao(assunto)"
          >
            {{ assunto.titulo }}
          </li>
        </ul>

        <div class="acoes-popup">
          <button
            class="btn-enviar"
            :disabled="!selecionados.length"
            @click="confirmarEnvio"
          >
            Enviar Mensagem
          </button>
          <button class="btn-fechar-popup" @click="fecharPopup">Fechar</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { registrarOuvirWhatsGlobal, enviarParaObrigado } from "@/utils";

// Estado do popup
const popupAberto = ref(false);
const selecionados = ref([]);

// Lista oficial de assuntos
const assuntos = [
  { titulo: "📦 Locação de Máquinas", value: "locacao" },
  { titulo: "💰 Venda de Máquinas", value: "vendas" },
  { titulo: "🎓 Treinamentos Click", value: "treinamento" },
  { titulo: "💼 Licenciamento de Marca", value: "licenciamento" },
  { titulo: "💬 Suporte", value: "suporte" },
];


// Seleciona/deseleciona
function toggleSelecao(assunto) {
  const i = selecionados.value.indexOf(assunto);
  if (i > -1) selecionados.value.splice(i, 1);
  else selecionados.value.push(assunto);
}

// Fecha popup
function fecharPopup() {
  popupAberto.value = false;
  selecionados.value = [];
}


// NOVA FUNÇÃO: fluxo correto → /obrigado
function confirmarEnvio() {
  if (!selecionados.value.length) return;

  // 🔥 Dispara evento final de clique para GA4/GTM
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    selecionados: selecionados.value.map(a => a.value).join(", "),
    origem: "popup_final_click"
  });

  // 🔥 Envia para página Obrigado (funil oficial)
  enviarParaObrigado(selecionados.value);

  fecharPopup();
}


// Ouvinte global do popup
let stopOuvirWhats;

onMounted(() => {
  stopOuvirWhats = registrarOuvirWhatsGlobal({
    assuntos,
    selecionados,
    popupAberto,
  });
});

onBeforeUnmount(() => {
  if (stopOuvirWhats) stopOuvirWhats();
});
</script>

<style scoped>
/* (mesmo CSS original do popup, preservado 100%) */

.popup-whatsapp {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5000;
  backdrop-filter: blur(6px);
}

.popup-conteudo {
  background: rgba(0, 0, 0, 0.95);
  color: #fff;
  padding: 26px;
  border-radius: 20px;
  width: 90%;
  max-width: 420px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  animation: slideFadeIn 0.35s ease forwards;
}

.popup-conteudo h3 {
  color: var(--rosa-principal, #ff2e79);
  margin-bottom: 6px;
}

.popup-conteudo p {
  font-size: 0.95rem;
  color: #ccc;
  margin-bottom: 16px;
}

/* Lista */
.lista-assuntos {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.lista-assuntos li {
  padding: 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.25s ease;
}
.lista-assuntos li:hover {
  background: rgba(255, 255, 255, 0.12);
}
.lista-assuntos li.ativo {
  background: var(--rosa-principal, #ff2e79);
  color: #fff;
  font-weight: 600;
}

/* Botões */
.acoes-popup {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.btn-enviar {
  background: linear-gradient(90deg, #ff2e79, #ffc300);
  border: none;
  color: #fff;
  border-radius: 10px;
  padding: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s;
}
.btn-enviar:hover {
  background: linear-gradient(90deg, #ff4c7a, #ffd13b);
  transform: scale(1.02);
}
.btn-enviar:disabled {
  background: #555;
  cursor: not-allowed;
}
.btn-fechar-popup {
  background: transparent;
  color: #bbb;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}
.btn-fechar-popup:hover {
  color: var(--rosa-principal, #ff2e79);
}

/* Animações */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes slideFadeIn {
  from {
    opacity: 0;
    transform: translateY(-15px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
